import { FC } from 'react';
import { Card, Descriptions, Empty, Alert, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { MedicalInfoAdmin } from '../../../../../models/admin/student-admin.model';

const { Text } = Typography;

interface MedicalTabProps {
  medicalInfo: MedicalInfoAdmin | null;
}

const MedicalTab: FC<MedicalTabProps> = ({ medicalInfo }) => {
  if (!medicalInfo) {
    return (
      <Card title="Medical Information">
        <Empty description="No medical information on file" />
      </Card>
    );
  }

  const hasAllergies =
    medicalInfo.allergies ||
    medicalInfo.allergiesSummary ||
    medicalInfo.dietaryRestrictions;

  return (
    <div>
      {hasAllergies && (
        <Alert
          message="Allergy Alert"
          description={
            <div>
              {medicalInfo.allergiesSummary && (
                <div>
                  <Text strong>Summary: </Text>
                  {medicalInfo.allergiesSummary}
                </div>
              )}
              {medicalInfo.allergies && (
                <div>
                  <Text strong>Details: </Text>
                  {medicalInfo.allergies}
                </div>
              )}
              {medicalInfo.dietaryRestrictions && (
                <div>
                  <Text strong>Dietary Restrictions: </Text>
                  {medicalInfo.dietaryRestrictions}
                </div>
              )}
            </div>
          }
          type="warning"
          showIcon
          icon={<WarningOutlined />}
          style={{ marginBottom: 16 }}
        />
      )}

      <Card title="Medical Information">
        <Descriptions column={1} bordered size="small">
          <Descriptions.Item label="Allergies">
            {medicalInfo.allergies || 'None reported'}
          </Descriptions.Item>
          <Descriptions.Item label="Chronic Conditions">
            {medicalInfo.chronicConditions || 'None reported'}
          </Descriptions.Item>
          <Descriptions.Item label="Current Medications">
            {medicalInfo.medications || 'None reported'}
          </Descriptions.Item>
          <Descriptions.Item label="Dietary Restrictions">
            {medicalInfo.dietaryRestrictions || 'None reported'}
          </Descriptions.Item>
          <Descriptions.Item label="Special Needs">
            {medicalInfo.specialNeeds || 'None reported'}
          </Descriptions.Item>
          <Descriptions.Item label="Activity Restrictions">
            {medicalInfo.activityRestrictions || 'None reported'}
          </Descriptions.Item>
          <Descriptions.Item label="Other Medical Info">
            {medicalInfo.otherMedicalInfo || 'None reported'}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default MedicalTab;
